(ns ui.instagram-connect.oauth-return
  "The return of the Instagram Accounts page from the OAuth of a
   fallback connection, like `app.bundle-social.page/on-load`: the url
   carries the new team as `?team=`, and a failed connect an OAuth error
   as well. The team is synced in both cases, since the sync is what
   removes an empty team, which bundle.social keeps counting."
  (:require [app.bundle-social.platforms :as platforms]))

(defn actions
  "The actions for the url's `query-params`; `refresh` are the actions
   after the sync."
  [query-params refresh]
  (let [team-id (not-empty (:team query-params))
        message (platforms/callback-message query-params)]
    (cond-> [[:store/assoc ::callback-message message]
             [:store/assoc ::syncing-team team-id]]
      message
      (conj [:social-accounts/forget-team-param])

      team-id
      (conj [:social-accounts/sync team-id {:on-done refresh}]))))
